import {Stack} from '@mui/material';
import React, {Fragment} from 'react';

import {SALUDIA_URLS, useSaludiaExperience} from 'presentation/hooks/useSaludiaExperience';
import {useOpenOptionsDrawerStore} from 'presentation/pages/private/store/useOpenOptionsDrawer';
import {useSaludiaDrawerStore} from 'presentation/pages/private/store/useSaludiaDrawerStore';
import {translations} from 'presentation/translations-new';

import {SaludiaAvailability} from './components/SaludiaAvailability';
import {SaludiaCardCode} from './components/SaludiaCardCode';
import {SaludiaDrawer} from './components/SaludiaDrawer';
import {StyledAttentionDescription, StyledDescription, StyledSubtitle} from './styles';

const {
	infoTitle,
	infoSubtitle,
	infoDescription,
	understood,
	attentionTitle,
	attentionDescription,
	continue: continueLabel,
} = translations['pt-br'].privateFlow.services.saludia;

export function SaludiaDrawers() {
	const {activeSaludiaDrawer, returnToOptionsDrawer, origin, closeSaludiaDrawer} =
		useSaludiaDrawerStore();
	const reopenOptionsDrawer = useOpenOptionsDrawerStore(state => state.reopenOptionsDrawer);
	const {cardCode} = useSaludiaExperience();

	const handleBackToOptions = () => {
		closeSaludiaDrawer();
		if (returnToOptionsDrawer) reopenOptionsDrawer();
	};

	const handleContinue = () => {
		window.open(SALUDIA_URLS[origin], '_blank', 'noopener,noreferrer');
		handleBackToOptions();
	};

	return (
		<Fragment>
			<SaludiaDrawer
				open={activeSaludiaDrawer === 'info'}
				title={infoTitle}
				buttonTitle={understood}
				description={
					<Stack flex={1} gap={2}>
						<Stack gap={0.5}>
							<StyledSubtitle>{infoSubtitle}</StyledSubtitle>
							<StyledDescription>{infoDescription}</StyledDescription>
						</Stack>
						<SaludiaAvailability />
					</Stack>
				}
				compactOnMobile={{iconAlign: 'flex-start', gap: '16px'}}
				onClose={handleBackToOptions}
				onConfirm={handleBackToOptions}
			/>

			<SaludiaDrawer
				open={activeSaludiaDrawer === 'card-code'}
				title={attentionTitle}
				buttonTitle={continueLabel}
				description={<StyledAttentionDescription>{attentionDescription}</StyledAttentionDescription>}
				compactOnMobile={{iconAlign: 'center', gap: '10px'}}
				onClose={handleBackToOptions}
				onConfirm={handleContinue}>
				<SaludiaCardCode value={cardCode} />
			</SaludiaDrawer>
		</Fragment>
	);
}
